import { DSAttendanceStatus } from '@/constants/ds-attendance.constants'
import PATHS from '@/router/paths'

/**
 * Rota do registro por status. Vivia dentro de `Index.vue`; saiu para cá quando o
 * "próximo registro da fila" (Eixo 4 da discovery 2026-09-11) passou a precisar da mesma
 * resolução fora da lista — duas cópias divergiriam no primeiro status novo.
 *
 * Status sem rota (nenhum hoje) devolve `null`: a navegação não acontece em vez de empurrar
 * o auditor para uma rota inexistente.
 */
export const STATUS_ROUTE_MAP: Partial<Record<DSAttendanceStatus, string>> = {
  [DSAttendanceStatus.PENDING_AUDIT]: 'DsAttendancePendingAudit',
  [DSAttendanceStatus.AUDIT_IN_PROGRESS]: 'DsAttendancePendingAudit',
  [DSAttendanceStatus.REJECTED]: 'DsAttendancePendingAudit',
  [DSAttendanceStatus.PENDING_SUBMISSION]: 'DsAttendancePendingSubmission',
  [DSAttendanceStatus.DELETED]: 'DsAttendancePendingSubmission',
  [DSAttendanceStatus.APPROVED]: 'DsAttendanceApproved'
}

export function routeNameForStatus(status: DSAttendanceStatus | string | null): string | null {
  if (!status) return null
  return STATUS_ROUTE_MAP[status as DSAttendanceStatus] ?? null
}

/**
 * O MESMO mapa em forma de caminho, para quem abre o card em nova aba
 * (`window.open`) e não pode usar o nome da rota. Vive junto do mapa canônico
 * porque a alternativa — um `if` de dois braços no consumidor — já mandou uma
 * solicitação `PENDING_SUBMISSION` para a tela de auditoria pendente.
 */
const STATUS_PATH_MAP: Partial<Record<DSAttendanceStatus, string>> = {
  [DSAttendanceStatus.PENDING_AUDIT]: PATHS.DS_ATTENDANCE_PENDING_AUDIT,
  [DSAttendanceStatus.AUDIT_IN_PROGRESS]: PATHS.DS_ATTENDANCE_PENDING_AUDIT,
  [DSAttendanceStatus.REJECTED]: PATHS.DS_ATTENDANCE_PENDING_AUDIT,
  [DSAttendanceStatus.PENDING_SUBMISSION]: PATHS.DS_ATTENDANCE_PENDING_SUBMISSION,
  [DSAttendanceStatus.DELETED]: PATHS.DS_ATTENDANCE_PENDING_SUBMISSION,
  [DSAttendanceStatus.APPROVED]: PATHS.DS_ATTENDANCE_APPROVED
}

/**
 * Caminho do container por status. Status ausente ou desconhecido (backend novo,
 * front antigo) cai na auditoria pendente — o destino de antes de este status
 * existir, e o único que nunca some.
 */
export function pathForStatus(
  attendanceId: number | string,
  status: DSAttendanceStatus | string | null | undefined
): string {
  const template =
    STATUS_PATH_MAP[status as DSAttendanceStatus] ?? PATHS.DS_ATTENDANCE_PENDING_AUDIT
  return template.replace(':attendanceId', String(attendanceId))
}
